const baseStyle = {
  backgroundColor: `gray.75`,
  border: `2px solid`,
  borderColor: `gray.75`,
  color: `heading`,
  fontSize: `md`,
  height: `auto`,
  fontWeight: `semibold`,
  lineHeight: `normal`,
  p: 4,
  _placeholder: {
    color: `placeholder`,
  },
};

const variants = {
  withIcon: {
    pl: 16,
  },
};

export const Input = {
  baseStyle,
  variants,
};
